import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Briefcase, Cpu, Link2 } from 'lucide-react';
import { Container, SectionHeading, fadeInUp } from './shared';

const GapSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="relative py-24 sm:py-32">
      <Container>
        <div className="grid gap-16 lg:grid-cols-2 lg:items-center lg:gap-20">
          <div>
            <SectionHeading
              align="left"
              eyebrow={t('landing.gap.eyebrow')}
              title={
                <>
                  {t('landing.gap.titleLine1')}
                  <br />
                  {t('landing.gap.titleLine2')}
                </>
              }
              subtitle={t('landing.gap.subtitle')}
            />

            <motion.div
              variants={fadeInUp}
              custom={2}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
              className="mt-10 rounded-2xl border border-white/[0.08] bg-white/[0.04] p-6 backdrop-blur-xl"
            >
              <p className="text-xl font-semibold text-white">{t('landing.gap.statement')}</p>
              <p className="mt-3 leading-relaxed text-brand-muted">{t('landing.gap.supporting')}</p>
            </motion.div>
          </div>

          <motion.div
            variants={fadeInUp}
            custom={1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.4 }}
            className="relative mx-auto flex w-full max-w-md items-center justify-between"
          >
            <div className="glass-card flex flex-col items-center gap-3 rounded-2xl px-6 py-8">
              <Briefcase className="h-8 w-8 text-brand-secondary" />
              <span className="text-sm font-semibold text-white">{t('landing.gap.business')}</span>
            </div>

            <div className="mx-3 flex flex-1 flex-col items-center">
              <div className="h-px w-full bg-gradient-to-r from-transparent via-brand-primary to-transparent" />
              <div className="relative -mt-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-button shadow-glow">
                <Link2 className="h-5 w-5 text-white" />
              </div>
              <span className="mt-3 text-xs font-bold uppercase tracking-wider text-white">
                Alenis
              </span>
            </div>

            <div className="glass-card flex flex-col items-center gap-3 rounded-2xl px-6 py-8">
              <Cpu className="h-8 w-8 text-brand-secondary" />
              <span className="text-sm font-semibold text-white">{t('landing.gap.it')}</span>
            </div>
          </motion.div>
        </div>
      </Container>
    </section>
  );
};

export default GapSection;
